import { z } from 'zod';
import { emailSchema, paginationSchema, text } from './common.js';
export const COLOR_PRESET_COUNT = 10;
export const userSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    email: z.string(),
    roleId: z.number().int(),
    role: z.string(),
    clusterId: z.number().int().nullable(),
    facilityIds: z.array(z.number().int()),
    colorPreset: z.number().int(),
    calendarTag: z.string().nullable(),
    isActive: z.boolean(),
    lastLoginAt: z.string().nullable(),
    createdAt: z.string(),
});
/** Minimal shape for dropdowns; any signed-in user may read it. */
export const userPickerSchema = userSchema.pick({ id: true, name: true, colorPreset: true });
export const userCreateSchema = z.object({
    name: text(2, 120),
    email: emailSchema,
    roleId: z.number().int().positive(),
    clusterId: z.number().int().positive().nullable().optional(),
    facilityIds: z.array(z.number().int().positive()).max(200).optional(),
    colorPreset: z
        .number()
        .int()
        .min(0)
        .max(COLOR_PRESET_COUNT - 1)
        .optional(),
    isActive: z.boolean().optional(),
});
export const userEditSchema = userCreateSchema.partial();
export const userListQuerySchema = paginationSchema.extend({
    q: z.string().trim().max(120).optional(),
    roleId: z.coerce.number().int().positive().optional(),
    active: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
    /** Limited view for dropdowns: technicians only, minimal fields. */
    picker: z.enum(['technicians', 'administrators']).optional(),
    /** With picker=technicians: only technicians with a visit the caller can see in this cluster (T44). */
    clusterId: z.coerce.number().int().positive().optional(),
});
export const reassignVisitsSchema = z.object({ toTechnicianId: z.number().int().positive() });
/** Deterministic default color so a technician keeps the same tag color everywhere. */
export function colorPresetFor(name) {
    let h = 0;
    for (const ch of name)
        h = (h * 31 + ch.charCodeAt(0)) >>> 0;
    return h % COLOR_PRESET_COUNT;
}
//# sourceMappingURL=users.js.map